import { FileRecordDto } from '@careapp-group/ng-sdk';
import { CareAppListActionFactory } from '../action-factory';

export const CustomerFiles = new CareAppListActionFactory<FileRecordDto>('CustomerFiles');
